<template>
<div class="d-none d-sm-block col-sm-6 col-md-7 col-lg-6 col-xl-4">
  <div class="row align-items-center">
    <div class="d-none d-sm-block col-sm-4 col-md-4">
      <h5 class="font-weight-bold" style="text-transform:uppercase;">
        <span>{{ user_location }}</span>
        <span class="region"> Madeira</span>
      </h5>
    </div>
    <div class="d-none d-sm-block col-sm-4 col-md-4 text-center">          
      <img class="center-block" id="weather-icon" :src="'/public/assets/animated-climacons/'+weather.icon" width="65px">
    </div>
    <div class="d-none d-sm-block col-sm-4 col-md-4">
      <div style="display:flex; flex-direction: column; flex-grow:1; text-align:center">
        <div class="weather-temperature"><span>{{ weather.temperature }}ºC</span></div>
        <div class="weather-description d-none d-md-block">{{ weather.description }}</div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Weather',
  data(){
    return {
      requestInterval: null,
      weather: { 
        temperature: null,
        description: null,
        local: null,
        id: null
      },
    }
  },
  mounted: function(){
    this.create_interval()
    this.getWeather()
  },
  destroyed: function(){
    clearInterval(this.requestInterval)
  },
  methods: {
    create_interval: function(){
      const self = this
      if(this.requestInterval != null) clearInterval(this.requestInterval)
      this.requestInterval = setInterval( () => { self.getWeather() }, 300000)
    },
    getWeather: function(){
      this.$store.dispatch('getWeather').then((response) => {
        const current_weather = response
        this.getWeatherInfo(current_weather.idTipoTempo)
        this.weather.id = current_weather.idTipoTempo
        this.weather.temperature = Math.round(current_weather.tMed)
      })
    },
    getWeatherInfo: function(id){
      let description = null
      let icon = null
      if (id == 1) { description = this.$i18n.t('Clear'); icon = "sun.svg";}
      else if (id == 2) { description = this.$i18n.t('Partly_cloudy'); icon = "cloudSun.svg";}
      else if (id == 3 || id == 25) { description = this.$i18n.t('Partly_cloudy'); icon = "cloudSun.svg";}
      else if (id == 4 || id == 5 || id == 16 || id == 24) { description = this.$i18n.t('Cloudy'); icon = "cloud.svg";}
      else if (id == 6 || id == 7) { description = this.$i18n.t('Showers'); icon = "cloudRain.svg";}
      else if (id == 8) { description = this.$i18n.t('Rainy'); icon = "cloudDrizzle.svg";}
      else if (id >= 9 || id <= 15) { description = this.$i18n.t('Rainy'); icon = "cloudRain.svg"}
      else if (id >= 17) { description = this.$i18n.t('Fog'); icon = "cloudFog.svg";}
      else if (id >= 18) { description = this.$i18n.t('Snowy'); icon = "cloudSnow.svg";}
      else if (id >= 19) { description = this.$i18n.t('Thunderstorm'); icon = "cloudLightning.svg";}
      else if (id == 20 || id == 23) { description = this.$i18n.t('Heavy_rain');icon ="cloudRain.svg";}
      else if (id == 21) { description =  this.$i18n.t("Hail"); icon = "cloudHailAlt.svg";}
      else if (id == 22 || id == 26) { description =  this.$i18n.t("Wind"); icon = "wind.svg";}

      this.weather.description = description
      this.weather.icon = icon
    }
  },
  computed: {
    current_lang: function(){
      return this.$i18n.locale
    },
    user_location: function(){
      return this.$store.getters.user_location
    }
  },
  watch: {
    current_lang: function(){
      this.getWeatherInfo(this.weather.id)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.weather-description {
  font-size: 12px; 
  line-height: 14.2px;
}

.weather-temperature{
  font-size:28px; 
  line-height: 32.2px; 
  font-weight:700
}

.region {
  display: block; 
  font-size: 14px; 
  line-height: 16.2px; 
  font-weight:400;
}
</style>
